export enum CurrencyType {
  Fiat = 1,
  CryptoCurrency = 2,
}
